
<template>
  <nav class="dashboard_menu">
    <div class="nav nav-tabs" role="tablist">
      <router-link
          :to="{ name: 'dashboardHeadPsychosocialServicesInfo'}"
          :class="{ active: $route.name === 'dashboardHeadPsychosocialServicesInfo' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.info') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardHeadPsychosocialServicesCoaches' }"
          :class="{ active: $route.name === 'dashboardHeadPsychosocialServicesCoaches' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.coaches') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardHeadPsychosocialServicesPotentialUnits' }"
          :class="{ active: $route.name === 'dashboardHeadPsychosocialServicesPotentialUnits' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.preview_units_locations') }}
      </router-link>
      <router-link
          :to="{ name: 'dashboardHeadPsychosocialServicesUnitsDoneByLocation' }"
          :class="{ active: $route.name === 'dashboardHeadPsychosocialServicesUnitsDoneByLocation' }"
          class="nav-item nav-link" role="tab">
        {{ $t('dashboard.tabs.filterLocation') }}
      </router-link>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink } from 'vue-router';
</script>

<style scoped>

</style>